<div class="flex h-screen bg-surface-100">
  <app-sidebar />

  @if (layout.mobileOpen()) {
    <div
      class="fixed inset-0 z-40 bg-black/50 sm:hidden"
      (click)="layout.mobileOpen.set(false)"
    ></div>
  }

  <div class="flex-1 flex flex-col min-h-0 overflow-hidden">
    <app-header class="mb-12" />
    <main class="flex-1 overflow-auto">
      <router-outlet />
    </main>
  </div>

  <app-toast />
</div>
